<template>
    <div 
        style="z-index: 99999999;"
        v-if="true" class='sm-modal-parent sm-modal-block'>
        <div  class='inl-100 small-modal'>
            <div v-if="true"
                class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
                <div class="relative w-auto my-6 mx-auto max-w-sm">
                    <!--content-->
                    <div
                        style="width: 400px"
                        class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <!--header-->
                        <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                            <h3 class="text-3xl font-semibold">
                                Подтвердите удаление
                            </h3>
                        </div>
                        <!--body-->
                        <!--footer-->
                        <div class="flex py-6 items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                            <div>
                                <button
                                    style="margin-right: 15px;"
                                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button" v-on:click="deleteRequest">
                                    Подтвердить
                                </button>
                            </div>
                            <button
                                class="bg-lightBlue-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                style="margin-right: 15px;"
                                type="button" v-on:click="modalClose">
                                Отменить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';

export default {
    name: "small-modal",
    data() {
        return {};
    },
    methods: {
        async deleteRequest() {
            await axios({
                method: "DELETE",
                params: {
                    uuid: this.$props.uuid,
                },
                data: {},
                url: API_CLIENT.tsorThemes + this.$props.uuid + '/',
                headers: HEADERS_TOKEN_JSON(),
            }).then((e) => {
                this.$parent.deleteData(e.data.data.index);
            }).catch(function (e) {
                console.log(e);
            });
        },
    },
    props: {
        modalClose: {},
        uuid: {}, 
        course: {}, 
    }
}
</script>

<style scoped>
.sm-modal-parent {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 16rem;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}
.small-modal {
    position: absolute;
    margin: 0;
    z-index: 99999;
}
</style>